import React from 'react';

export const Label = ({ children, htmlFor, mandatory = false, className = '' }) => {
    return (
        <label 
            htmlFor={htmlFor}
            className={`block text-base font-semibold text-text-primary mb-3 ${className}`}
        >
            {children}
            {mandatory && <span className="text-red-500 ml-1">*</span>}
        </label>
    );
};